import React, { useState } from 'react';
import { Plus, Command } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { useI18n } from '../i18n';
import { Input } from '../components/ui/input';

export function QuickCapture() {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const { createTask, currentWorkspace } = useWorkspace();
  const { t } = useI18n();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !currentWorkspace) return;
    setLoading(true);
    try {
      await createTask(title.trim());
      setTitle('');
    } catch (error) {
      console.error('Error creating task:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="relative" data-testid="quick-capture-form">
      <div className="relative group">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-2">
          <Plus className="w-5 h-5 text-zinc-500 group-focus-within:text-zinc-300 transition-colors" />
        </div>
        <Input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder={t('quickCapturePlaceholder')}
          disabled={loading || !currentWorkspace}
          className="w-full h-12 sm:h-14 pl-12 pr-12 sm:pr-24 bg-[#141416] border-white/10 text-zinc-100 text-sm sm:text-base placeholder:text-zinc-600 focus:border-zinc-500 focus:ring-1 focus:ring-zinc-500 rounded-xl transition-all duration-200"
          data-testid="quick-capture-input"
        />
        <div className="absolute right-4 top-1/2 -translate-y-1/2 hidden sm:flex items-center gap-1 text-zinc-600">
          <kbd className="px-2 py-1 text-xs bg-zinc-800 rounded border border-white/10">
            <Command className="w-3 h-3 inline" /> K
          </kbd>
        </div>
      </div>
    </form>
  );
}
